//OK
import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import {
  getInitFormData,
  getNoSlip,
  applySlip,
  CalAmBulk,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SN_TRA_NGO_REG_001_POP_001 from "../SN_TRA_NGO_REG_001/SN_TRA_NGO_REG_001_POP_001";
import SN_TRA_NGO_REG_001_POP_002 from "../SN_TRA_NGO_REG_001/SN_TRA_NGO_REG_001_POP_002";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import SnButton from "@shared/components/SnButton";
import ComCreateUi from "@menu/COM/ComCreateUi";
import layout from "./SN_TRA_NGO_REG_001.json";
import FreeForm from "@widgets/FreeForm";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_TRA_NGO_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });
  const formRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    freeform1: React.createRef(),
  });
  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });
  const [headerInfo, setHeaderInfo] = useState<any>({
    freeform1: {},
  });
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  //#endregion

  //#region  Components useState
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [gridFocus1, setGridFocus1] = useState(false);

  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_TRA_NGO_REG_001";
  const defaultSize = {
    panel1: "89.5%",
    panel2: "10.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  const [formRefresh, setFormRefresh] = useState(0);
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
        setHeaderInfo({
          freeform1: rtn.header.freeform1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = formRefs.current["freeform1"].current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
        return;
      }
    }
    try {
      await search_popup();
    } catch (error) {}
  };
  //region getPopupInitialData
  const getPopupInitialData = () => {
    let cd_cust = "";
    let nm_cust = "";

    const formData = formRefs.current["freeform1"].current.getFormdata();
    if (formData) {
      cd_cust = formData.cd_cust || "";
      nm_cust = formData.nm_cust || "";
    }

    return { cd_cust, nm_cust };
  };
  //region search_popup
  const search_popup = async () => {
    const selectedData = getPopupInitialData();

    const component = (
      <SN_TRA_NGO_REG_001_POP_001 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "NEGO조회",
      children: component,
    });
    if (!result || result === "close") return;
    const headerResult = result[0];
    const newData = { no_nego: headerResult[0].no_nego };
    const params = {
      id: "sn_tra_ngo_reg_001_02",
      params: { ...newData },
    };
    const data: any = await fnGetDataSet(params);
    setFormDatas({
      freeform1: data[0][0],
    });
  };
  //region onInsert
  const onInsert = async () => {
    try {
      const modifiedRowsH = formRefs.current["freeform1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }
      formRefs.current["freeform1"].current.resetUpdate();
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        nm_biz: userInfo.nm_biz,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_nego: todayform,
        yn_docu: "N",
        tp_nego: "52",
        fg_nego: "1",
        no_line_docu: 0,
        cd_exch: "001",
        cd_exch_a: "001",
        cd_exch_h: "001",
        cd_exch_hl: "001",
        cd_exch_l: "001",
        fg_trns: 1,
        rt_exch: 1,
      };
      formRefs.current["freeform1"].current.addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //region onDelete
  const onDelete = async () => {
    if (!formRefs.current["freeform1"].current.checkDataExist()) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제 하시겠습니까?");
    if (!confirm) {
      return;
    }

    formRefs.current["freeform1"].current?.deleteForm();

    return await onSave();
  };

  //region OnSave
  const onSave = async () => {
    try {
      const requiredValuesCheckH =
        formRefs.current["freeform1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const traNegoChanges = formRefs.current["freeform1"].current.getChange();

      if (traNegoChanges) {
        if (traNegoChanges.insert?.length > 0) {
          const row = traNegoChanges.insert[0];
          row.no_docu = row.yn_docu === "Y" ? "Y" : null;
        }

        // update 있을 때
        if (traNegoChanges.update?.length > 0) {
          const row = traNegoChanges.update[0];
          row.no_docu = row.yn_docu === "Y" ? "Y" : null;
        }
      }
      if (traNegoChanges.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const headerInserts = traNegoChanges.insert ?? [];
      if (headerInserts.length !== 0) {
        const noSlip = await applySlip({
          cd_column: "no_nego",
          cd_module: Menuprops.cd_module,
          no_line: 1,
          cd_prefix: "NGO",
          dt: headerInserts[0]?.dt_open,
          formrefs: [formRefs.current["freeform1"]],
          inserts: [traNegoChanges],
          cd_menu: Menuprops.cd_menu,
        });
      }
      const SaveData = {
        tra_nego: traNegoChanges,
      };
      await fnSave("SN_TRA_NGO_REG_001_SAVE_01", SaveData);
      formRefs.current["freeform1"].current.resetUpdate();
    } catch (error: any) {}
  };

  //region onBeforeAddRowH

  //region BTNclick
  const onGridBtnsClick = async (id: string) => {
    if (id === "btnApply") {
      const modifiedRowH = formRefs.current["freeform1"].current.getChange();
      if (modifiedRowH.insert.length == 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const component = <SN_TRA_NGO_REG_001_POP_002 />;
      const result = await showPopupModal({
        title: "B/L적용",
        children: component,
        width: "80%",
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      const lineResult: any[] = result[1];
      if (headerResult[0]) {
        for (const key in headerResult[0]) {
          formRefs.current["freeform1"].current.setDataValue(
            key,
            headerResult[0][key],
            "noEvent"
          );
        }
      }
      lineResult.map((result: any) => {
        for (const key in result) {
          if (key === "am_k" || key === "rt_exch" || key === "am") continue;
          formRefs.current["freeform1"].current.setDataValue(
            key,
            result[key],
            "noEvent"
          );
        }
        formRefs.current["freeform1"].current.setDataValue(
          "am_target",
          result.am_c,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue(
          "no_bl",
          result.no_sales,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue(
          "cd_exch_h",
          result.cd_exch,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue(
          "cd_exch_hl",
          result.cd_exch,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue(
          "cd_exch_l",
          result.cd_exch,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue(
          "rt_exch_target",
          result.rt_exch,
          "noEvent"
        );
        formRefs.current["freeform1"].current.setDataValue("am", result.am_c);
      });
    } else if (id === "btn_rt_exch") {
      const left = window.screenX + (window.outerWidth - 200) / 2;
      const top = window.screenY + (window.outerHeight - 200) / 2;
      const popup = window.open(
        "https://spot.wooribank.com/pot/Dream?withyou=FXCNT0002&rc=0&divType=1&lang=KOR#none",
        "wooriPopup",
        `width=200,height=200,scrollbars=yes,left=${left},top=${top}`
      );
    }
  };
  //region onFocusedRowChanged
  //region OnValueChanged
  const onValueChaged = async (event: ValueChangedEvent) => {
    let rtnData: any = {};
    const colId = event.colId;
    const rowData = event.rowData;

    const n = (val: any) => Number(val ?? 0);

    const am = n(rowData.am);
    const am_fee_ex = n(rowData.am_fee_ex);
    const am_k_fee = n(rowData.am_k_fee);
    const rt_exch = n(rowData.rt_exch);
    const rt_exch_target = n(rowData.rt_exch_target);

    const am_col = am - am_fee_ex - (rt_exch === 0 ? 0 : am_k_fee / rt_exch);

    if (colId === "rt_exch_target") {
      // 기표환율
      return {
        am_k_target: am * rt_exch_target, // 기표원화금액
        am_k_pl: am_col * (rt_exch - rt_exch_target), // 외환차손익
      };
    } else if (colId === "am") {
      // NEGO금액
      return {
        am_k_target: am * rt_exch_target, // 기표원화금액
        am_k: am * rt_exch, // NEGO 원화
        am_col: am_col, // 실입금액
        am_k_col: am_col * rt_exch, // 실입금액(원화)
        am_k_pl: am_col * (rt_exch - rt_exch_target), // 외환차손익
      };
    } else if (colId === "cd_exch") {
      // NEGO금액 환종
      return {
        cd_exch_h: rowData.cd_exch,
        cd_exch_hl: rowData.cd_exch,
        cd_exch_l: rowData.cd_exch,
      };
    } else if (colId === "am_fee_ex") {
      // 외화
      return {
        am_k_fee_ex: rt_exch * am_fee_ex, // 원화
        am_col: am_col, // 실입금액
        am_k_col: am_col * rt_exch, // 실입금액(원화)
        am_k_pl: am_col * (rt_exch - rt_exch_target), // 외환차손익
      };
    } else if (colId === "rt_exch") {
      // NEGO 환율
      return {
        am_k_target: am * rt_exch_target, // 기표원화금액
        am_k: am * rt_exch, // NEGO 원화
        am_k_fee_ex: rt_exch * am_fee_ex, // 원화
        am_fee: rt_exch === 0 ? 0 : am_k_fee / rt_exch, // (외화)
        am_k_col: am_col * rt_exch, // 실입금액(원화)
        am_k_pl: am_col * (rt_exch - rt_exch_target), // 외환차손익
      };
    } else if (colId === "am_k_fee") {
      // 원화
      return {
        am_fee: rt_exch === 0 ? 0 : am_k_fee / rt_exch, // (외화)
        am_col: am_col, // 실입금액
        am_k_col: am_col * rt_exch, // 실입금액(원화)
        am_k_pl: am_col * (rt_exch - rt_exch_target), // 외환차손익
      };
    }
  };

  // #endregion
  const forms = useMemo(
    () => ({
      freeform1: {
        controls: formControls.freeform1,
        data: formDatas.freeform1,
        etcProps: { title: "NEGO수수료" },
        events: {
          onValueChanged: onValueChaged,
          onBtnEtcClick: onGridBtnsClick,
        },
        headerInfo: headerInfo.freeform1,
      },
    }),
    [formControls, formDatas, headerInfo]
  );
  //#region  UI
  const dynamicProps = React.useMemo(
    () => ({
      forms,
      formRefs,
    }),
    [forms, formRefs]
  );
  //region UI
  return <ComCreateUi dynamicProps={dynamicProps} layoutConfig={layout} />;

  //#endregion
});
export default SN_TRA_NGO_REG_001;
